/* artvision® · Header über dem Hero
   Der Header liegt auf der Startseite transparent über dem Motiv.
   Sobald gescrollt wird, bekommt er wieder Fläche und Kante —
   sonst läge Navigation auf Werken.

   Das Theme setzt beim Scrollen keine eigene Klasse (der Sticky-
   Zustand steht schon beim Laden), deshalb dieser kleine Schalter. */
(function () {
  var body = document.body;
  if (!body.classList.contains('av-hdr-overlay')) return;

  /* Was über dem Hero steht — die Announcement Bar — von der
     Fensterhöhe abziehen, damit der Vollbild-Hero exakt bis zur
     Unterkante reicht und nicht darüber hinausläuft. */
  function measureAbove() {
    var hero = document.querySelector('.av-hero--full');
    if (!hero) return;
    var above = 0;
    var el = document.querySelector('.shopify-section-group-header-group');
    while (el && !el.querySelector('header.header')) {
      above += el.offsetHeight;
      el = el.nextElementSibling;
    }
    document.documentElement.style.setProperty('--av-above-hero', above + 'px');
  }
  measureAbove();
  window.addEventListener('resize', measureAbove, { passive: true });

  /* Liegt ein dunkler Hero darunter, braucht die transparente
     Navigation die inverse Farbe — sonst steht dunkle Schrift auf
     dunklem Scrim. Als Klasse am body, damit die Header-Regeln
     außerhalb der Sektion darauf zugreifen können. */
  if (document.querySelector('.av-hero--dark')) body.classList.add('av-hero-dark');

  var ticking = false;
  /* Zweite Schwelle: ist der Hero durchgescrollt? Daran hängt das
     Trusted-Shops-Siegel, das sonst über der Weltenzeile klebt. */
  function heroBottom() {
    var hero = document.querySelector('.av-hero');
    if (!hero) return 0;
    return hero.offsetTop + hero.offsetHeight - 120;
  }

  /* Der Header wird über einen negativen Außenabstand aus dem Fluss
     genommen. Ein fester Wert reicht dafür nicht: die tatsächliche
     Höhe ist gebrochen (58,89 statt 58), und die Differenz blieb als
     helle Linie unter der Announcement Bar stehen. Deshalb die echte
     Höhe messen und als Variable setzen. */
  function measureHeader() {
    var wrap = document.querySelector('.header-wrapper');
    if (!wrap) return;
    var h = wrap.getBoundingClientRect().height;
    if (h > 0) document.documentElement.style.setProperty('--av-hdr-real-h', h + 'px');
  }
  measureHeader();
  window.addEventListener('resize', measureHeader, { passive: true });
  window.addEventListener('load', measureHeader);

  function update() {
    var y = window.scrollY;
    body.classList.toggle('av-scrolled', y > 40);
    body.classList.toggle('av-past-hero', y > heroBottom());
    ticking = false;
  }
  update();
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
})();
